import React, { Component } from 'react';
import { validateConstraints, validationImmutableReduxForm } from '../../../components/FormWrapper';
import { Field, FieldArray, formValueSelector } from 'redux-form/immutable';
import { Col, Row } from 'react-flexbox-grid';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import validate from 'validate.js';
import moment from 'moment';

import { Checkbox, DatePicker, TextField } from 'redux-form-material-ui';

validate.validators.passwordConfirmation = function(value, options, key, attributes) {
    const { attribute, message } = options;
    if (attributes[attribute] !== null && attributes[attribute] !== '') {
        if (attributes[attribute] !== value) {
            return message;
        }
    }
    return null;
};
validate.validators.decimal = function(value, options, key, attributes) {
    const array = ('' + value).split('.');
    if (array.length == 2) {
        if (array[1].length > 1) {
            return '^Bitte eine Zahl mit maximal einer Kommastelle eingeben';
        }
    }
    return null;
};

const formValidation = values =>
    validateConstraints(values.toJS(), {
        scan_timeout: {
            decimal: true,
        },
        article_pin: {
            format: {
                pattern: '^([\s]+)?$|[0-9]{4,20}',
                flags: 'ig',
                message: '^Bitte geben Sie mindestens 4 Zeichen ein.',
            },
        },
        report_pin: {
            format: {
                pattern: '^([\s]+)?$|[0-9]{4,20}',
                flags: 'ig',
                message: '^Bitte geben Sie mindestens 4 Zeichen ein.',
            },
        },
        // settings_pin: {
        //   length: {
        //     minimum: 4,
        //     message: "^Bitte geben Sie mindestens 4 Zeichen ein."
        //   }
        // },
        article_pin_confirmation: {
            passwordConfirmation: {
                attribute: 'article_pin',
                message: '^Die beiden Artikel-Pins stimmen nicht überein.',
            },
        },
        report_pin_confirmation: {
            passwordConfirmation: {
                attribute: 'report_pin',
                message: '^Die beiden Beleg-Pins stimmen nicht überein.',
            },
        },
        settings_pin_confirmation: {
            passwordConfirmation: {
                attribute: 'settings_pin',
                message: '^Die beiden Einstellungs-Pins stimmen nicht überein.',
            },
        },
        companyName: {
            presence: {
                message: '^Bitte geben Sie Ihren Firmennamen an',
                allowEmpty: false,
            },
        },
        email: {
            presence: {
                message: '^Bitte geben Sie eine E-Mail-Adresse ein',
                allowEmpty: false,
            },
        },
        postalCode: {
            presence: {
                message: '^Bitte geben Sie eine Postleitzahl ein',
                allowEmpty: false,
            },
        },
        street: {
            presence: {
                message: '^Bitte geben Sie eine Straße ein',
                allowEmpty: false,
            },
        },
        city: {
            presence: {
                message: '^Bitte geben Sie eine Stadt ein',
                allowEmpty: false,
            },
        },
    });

class DeviceGuidelinesForm extends Component {
    renderBarCodeTypes = ({ fields, meta: { touched, error } }) => {
        return (
            <div>
                {fields.map((receiver, index) => {
                    const model = fields.get(index);
                    return (
                        <Row key={`${receiver}.name`}>
                            <Col xs={3}>
                                <Field
                                    style={{ display: 'none' }}
                                    name={`${receiver}.name`}
                                    type="text"
                                    component={'input'}
                                />
                                <Field
                                    name={`${receiver}.enabled`}
                                    component={Checkbox}
                                    style={{ width: '100%' }}
                                    label={this.props.barCodeTypeNames.get(model.get('name'))}
                                />
                            </Col>
                            {model.get('name') === 'upc' && (
                                <Col xs={3}>
                                    <Field
                                        name={`${receiver}.checksum_ignored_enabled`}
                                        component={Checkbox}
                                        style={{ width: '100%' }}
                                        label="Prüfziffer weglassen"
                                    />
                                </Col>
                            )}
                            {model.get('name') === 'upc' && (
                                <Col xs={3}>
                                    <Field
                                        name={`${receiver}.add_leading_zero_enabled`}
                                        component={Checkbox}
                                        style={{ width: '100%' }}
                                        label="Führende 0 hinzufügen"
                                    />
                                </Col>
                            )}
                            {model.get('name') === 'itf' && (
                                <Col xs={3}>
                                    <Field
                                        name={`${receiver}.double_scan_check_enabled`}
                                        component={Checkbox}
                                        style={{ width: '100%' }}
                                        label="Doppelscan prüfen"
                                    />
                                </Col>
                            )}
                        </Row>
                    );
                })}
            </div>
        );
    };

    render() {
        const { handleSubmit, pristine } = this.props;
        return (
            <form onSubmit={handleSubmit}>
                <h3 style={{ marginTop: '30px', marginBottom: '30px' }}>Allgemein</h3>
                <Row>
                    <Col xs={12}>
                        <Row>
                            <Col xs={12} md={5} lg={5}>
                                <Row>
                                    <Field
                                        name="scan_timeout"
                                        component={TextField}
                                        type="text"
                                        style={{ width: '100%' }}
                                        floatingLabelText="Kamerapause"
                                    />
                                </Row>
                                <br />
                                <br />
                                <Row>
                                    <Field
                                        name="scan_sound"
                                        component={Checkbox}
                                        type="text"
                                        style={{ width: '100%' }}
                                        label="Scanner Sound"
                                    />
                                </Row>
                                <Row>
                                    <Field
                                        name="scandit_case"
                                        component={Checkbox}
                                        type="text"
                                        style={{ width: '100%' }}
                                        label="Scandit Case"
                                    />
                                </Row>
                                <Row>
                                    <Field
                                        name="amount_hidden"
                                        component={Checkbox}
                                        style={{ width: '100%' }}
                                        label="Menge oben nicht anzeigen"
                                    />
                                </Row>
                                <Row>
                                    <Field
                                        name="article_check_enabled"
                                        component={Checkbox}
                                        style={{ width: '100%' }}
                                        label="Artikeldaten prüfen"
                                    />
                                </Row>
                                <Row>
                                    <Field
                                        name="allow_wrong_article_enabled"
                                        component={Checkbox}
                                        style={{ width: '100%' }}
                                        label="Fehlartikel trotzdem prüfen"
                                    />
                                </Row>
                                <Row>
                                    <Field
                                        name="scan_button_enabled"
                                        component={Checkbox}
                                        style={{ width: '100%' }}
                                        label="Scan Button (Lautstärke-Minus)"
                                    />
                                </Row>
                                <Row>
                                    <Field
                                        name="delete_on_upload_enabled"
                                        component={Checkbox}
                                        style={{ width: '100%' }}
                                        label="Bericht nach senden löschen"
                                    />
                                </Row>
                                <Row>
                                    <Field
                                        name="upload_on_finish_enabled"
                                        component={Checkbox}
                                        style={{ width: '100%' }}
                                        label="Immer senden nach Beleg-Abschluss"
                                    />
                                </Row>
                            </Col>
                            <Col xs={12} mdOffset={1} md={5}>
                                <Row>
                                    <Field
                                        name="article_pin"
                                        component={TextField}
                                        style={{ width: '100%' }}
                                        type="number"
                                        floatingLabelText="Artikel-PIN"
                                    />
                                </Row>
                                {/* <Row>
                  <Field
                    name="article_pin_confirmation"
                    component={TextField}
                    type="number"
                    style={{width: "100%"}}
                    floatingLabelText="Artikel-PIN wiederholen"
                  />
                </Row> */}
                                <Row>
                                    <Field
                                        name="report_pin"
                                        component={TextField}
                                        type="number"
                                        style={{ width: '100%' }}
                                        floatingLabelText="Belege-PIN"
                                    />
                                </Row>
                                {/* <Row>
                  <Field
                    name="report_pin_confirmation"
                    component={TextField}
                    type="number"
                    style={{width: "100%"}}
                    floatingLabelText="Belege-PIN wiederholen"
                  />
                </Row> */}
                                <Row>
                                    <Field
                                        name="settings_pin"
                                        component={TextField}
                                        type="number"
                                        style={{ width: '100%' }}
                                        floatingLabelText="Einstellungs-PIN"
                                    />
                                </Row>
                                {/* <Row>
                  <Field
                    name="settings_pin_confirmation"
                    component={TextField}
                    type="number"
                    style={{width: "100%"}}
                    floatingLabelText="Einstellungs-PIN wiederholen"
                  />
                </Row> */}
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <h3 style={{ marginTop: '30px', marginBottom: '30px' }}>Inventur</h3>
                <Row>
                    <Col xs={12}>
                        <Row>
                            <Col xs={12} md={5} lg={5}>
                                <Row>
                                    <Field
                                        name="stocktaking_setting.target_amount_enabled"
                                        component={Checkbox}
                                        style={{ width: '100%' }}
                                        label="Sollmenge"
                                    />
                                </Row>
                                <Row>
                                    <Field
                                        name="stocktaking_setting.target_amount_check_enabled"
                                        component={Checkbox}
                                        style={{ width: '100%' }}
                                        label="Mengenprüfung"
                                    />
                                </Row>
                                <Row>
                                    <Field
                                        name="stocktaking_setting.summerize_multiple_scans_enabled"
                                        component={Checkbox}
                                        style={{ width: '100%' }}
                                        label="Mehrfachscan summieren"
                                    />
                                </Row>
                                <Row>
                                    <Field
                                        name="stocktaking_setting.default_indicator"
                                        component={TextField}
                                        type="number"
                                        style={{ width: '100%' }}
                                        floatingLabelText="Vorgabe Modekennzeichen"
                                    />
                                </Row>
                                <Row>
                                    <Field
                                        name="stocktaking_setting.default_admission_day"
                                        component={DatePicker}
                                        formatDate={date => {
                                            if (date !== null || date !== '') {
                                                return moment(date).format('LL');
                                            } else {
                                                return '';
                                            }
                                        }}
                                        style={{ width: '100%' }}
                                        floatingLabelText="Vorgabe Aufnahmetag"
                                    />
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <h3 style={{ marginTop: '30px', marginBottom: '30px' }}>Lieferantenretoure</h3>
                <Row>
                    <Col xs={12}>
                        <Row>
                            <Field
                                name="retour_setting.summerize_multiple_scans_enabled"
                                component={Checkbox}
                                style={{ width: '100%' }}
                                label="Mehrfachscan summieren"
                            />
                        </Row>
                    </Col>
                </Row>
                <h3 style={{ marginTop: '30px', marginBottom: '30px' }}>Umlagerung</h3>
                <Row>
                    <Col xs={12}>
                        <Row>
                            <Field
                                name="rearrangement_setting.summerize_multiple_scans_enabled"
                                component={Checkbox}
                                style={{ width: '100%' }}
                                label="Mehrfachscan summieren"
                            />
                        </Row>
                    </Col>
                </Row>
                <h3 style={{ marginTop: '30px', marginBottom: '30px' }}>Gültige Etikettenarten</h3>
                <Row>
                    <Col xs={12}>
                        <FieldArray
                            name="barcode_type_settings"
                            component={this.renderBarCodeTypes}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: '30px' }}>
                    <Col xs={12}>
                        <Row end="xs">
                            <Col xs={5}>
                                <RaisedButton
                                    label="Speichern"
                                    disabled={pristine}
                                    primary={true}
                                    type="submit"
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </form>
        );
    }
}

const selector = formValueSelector('deviceGuidelinesForm'); // <-- same as form name

export default connect(state => {
    return {
        all: selector(state, 'bar_code_types.all'),
    };
})(validationImmutableReduxForm('deviceGuidelinesForm', formValidation)(DeviceGuidelinesForm));
